"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBlockShortcut = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var WithColorFilterSubscription_1 = __importDefault(require("DreamCoat/WithColorFilterSubscription/WithColorFilterSubscription"));
var commonBlockOptions_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonBlockOptions");
var StyleShortCutContainer_1 = __importDefault(require("../../../Common/AtomicUI/StyleShortCutContainer/StyleShortCutContainer"));
var CommonBlockStyleShortcut_1 = __importDefault(require("../CommonBlockStyleShortcut/CommonBlockStyleShortcut"));
var CommonTextShortcut_1 = __importDefault(require("../CommonTextShortcut/CommonTextShortcut"));
var MotionShortcut_1 = __importDefault(require("../MotionShortcut/MotionShortcut"));
var CssEditor_1 = __importDefault(require("../CssEditor/CssEditor"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("DataStores/Account/Types");
var defaultProps = {
    filteredColors: [],
};
exports.TextBlockShortcut = (0, mobx_react_1.observer)(function (props) {
    var stylePermissionStore = props.stylePermissionStore, blockStore = props.blockStore, telemetry = props.telemetry;
    var blockStyleStore = blockStore.blockStyleStore;
    telemetry.trackOnly("Block Styles Shortcuts Viewed", {}, {
        blockIntercom: true,
    });
    var withBlockStyle = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Block);
    var withTextStyle = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Text);
    var withMotion = stylePermissionStore.allowStyle(Types_1.StyleAccessType.Motion);
    var withCssEditor = stylePermissionStore.shouldHaveCssEditor(blockStyleStore.model.css && blockStyleStore.model.css.length);
    return (react_1.default.createElement(StyleShortCutContainer_1.default, { lowPadding: true },
        react_1.default.createElement(kaleidoscope_1.Tabs, null,
            react_1.default.createElement(kaleidoscope_1.TabList, { isBordered: true, "aria-label": "Style options", align: kaleidoscope_1.TabListAlign.Center },
                withBlockStyle && react_1.default.createElement(kaleidoscope_1.Tab, null, "Block"),
                withTextStyle && react_1.default.createElement(kaleidoscope_1.Tab, null, "Text"),
                withMotion && react_1.default.createElement(kaleidoscope_1.Tab, null, "Animate"),
                withCssEditor && react_1.default.createElement(kaleidoscope_1.Tab, null, "CSS")),
            react_1.default.createElement(kaleidoscope_1.TabPanels, { transitionHeight: true },
                withBlockStyle && renderenderBlockTab(props),
                withTextStyle && renderenderTextTab(props),
                withMotion && renderenderMotionTab(props),
                withCssEditor && renderenderCssEditorTab(props)))));
});
var renderenderBlockTab = function (props) {
    var openBrandSetup = props.openBrandSetup, brandStore = props.brandStore, telemetry = props.telemetry, blockStore = props.blockStore, handleBackgroundChange = props.handleBackgroundChange, usingFeature = props.usingFeature;
    return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
        react_1.default.createElement("div", { className: "style-shortcut__main" },
            react_1.default.createElement(CommonBlockStyleShortcut_1.default, { handleBackgroundChange: handleBackgroundChange, openBrandSetup: openBrandSetup, blockWidthOptions: commonBlockOptions_1.blockWidthOptions, blockSpacingOptions: commonBlockOptions_1.blockSpacingOptions, blockHeightOptions: commonBlockOptions_1.blockHeightOptions, brandStore: brandStore, telemetry: telemetry, blockStore: blockStore, usingFeature: usingFeature }))));
};
var renderenderTextTab = function (props) {
    var filteredColors = props.filteredColors, telemetry = props.telemetry, blockStore = props.blockStore;
    return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
        react_1.default.createElement("div", { className: "style-shortcut__main" },
            react_1.default.createElement(CommonTextShortcut_1.default, { colors: filteredColors, blockStore: blockStore, telemetry: telemetry }))));
};
var renderenderMotionTab = function (props) {
    var telemetry = props.telemetry, blockStore = props.blockStore;
    return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
        react_1.default.createElement("div", { className: "style-shortcut__main" },
            react_1.default.createElement(MotionShortcut_1.default, { blockStore: blockStore, telemetry: telemetry }))));
};
var renderenderCssEditorTab = function (props) {
    var blockStore = props.blockStore;
    var blockStyleStore = blockStore.blockStyleStore;
    return (react_1.default.createElement(kaleidoscope_1.TabPanel, null,
        react_1.default.createElement("div", { className: "style-shortcut__main" },
            react_1.default.createElement(CssEditor_1.default, { blockStyleStore: blockStyleStore }))));
};
exports.TextBlockShortcut.defaultProps = defaultProps;
exports.default = (0, WithColorFilterSubscription_1.default)(exports.TextBlockShortcut);
